import { QueryClient } from '@tanstack/react-query'

import { isApiError } from '@/api/client'

/** Retry transient failures only: never 4xx (a 401 is handled by the auth layer's refresh). */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error)) {
    if (error.status === 401) return failureCount < 1
    if (error.status < 500) return false
  }
  return failureCount < 2
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 5 * 60_000,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  })
}
